import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

function sessionId() {
  let s = localStorage.getItem("ruleai_session");
  if (!s) {
    s = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("ruleai_session", s);
  }
  return s;
}

/**
 * Fires a POST /api/track on every route change. Public — no auth needed.
 * Skips app.* routes (private, less useful for marketing analytics).
 */
export default function PageViewTracker() {
  const loc = useLocation();
  useEffect(() => {
    // Skip in-app private routes to avoid noise. Still track /app landing hits.
    if (loc.pathname.startsWith("/app/")) return;
    api.post("/track", {
      path: loc.pathname + loc.search,
      session_id: sessionId(),
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    }).catch(() => {});
  }, [loc.pathname, loc.search]);
  return null;
}
